import { combineReducers } from 'redux';

import actionTypes from './actionTypes';
import dataTableReducer, { dataTableActionTypes } from './dataTable';
import defaults from './defaults';
import filterReducer, { filterActionTypes } from './filter';
import reportReducer from './report';

const isLegendActiveReducer = (state = defaults.isLegendActive, action) => {
    switch (action.type) {
        case actionTypes.SHOW_LEGEND:
            return action.payload.flag;
        case dataTableActionTypes.FETCH_DATA_REQUEST:
        case dataTableActionTypes.RESET_DATATABLE_STORE:
        case dataTableActionTypes.SET_SORT:
        case filterActionTypes.SET_POSITION:
        case filterActionTypes.SET_PLAYER_NATIONALITY:
        case filterActionTypes.SET_DRAFT_OVERALL_PICK:
        case filterActionTypes.SET_DRAFT_ROUND:
        case filterActionTypes.SET_DRAFT_YEAR:
        case filterActionTypes.SET_HEIGHT:
        case filterActionTypes.SET_LEFTY_OR_RIGHTY:
        case filterActionTypes.SET_STATE_OR_PROVINCE:
        case filterActionTypes.SET_STATUS:
        case filterActionTypes.SET_WEIGHT:
        case filterActionTypes.UPDATE_COLUMN_FILTER:
        case filterActionTypes.SET_DECISION:
        case filterActionTypes.SET_EXPERIENCE:
        case filterActionTypes.SET_GAME_LOCATION:
        case filterActionTypes.SET_OPPONENT_PLAYED_AGAINST:
        case filterActionTypes.SET_PLAYER_PLAYED_FOR:
            return false;
        default:
            return state;
    }
};

const reducer = combineReducers({
    dataTable: dataTableReducer,
    filter: filterReducer,
    isLegendActive: isLegendActiveReducer,
    report: reportReducer,
});

export default reducer;
